var _path, _path2, _path3, _path4, _path5, _path6, _path7, _polygon, _rect, _rect2, _path8, _rect3, _rect4, _path9, _polygon2, _rect5;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 360.89 83",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M87.08,67.57V14.29h10.66v22.18h20.09V14.29h10.73v53.28h-10.73v-21.53h-20.09v21.53h-10.66Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.46,67.93c-4.27,0-7.68-.56-10.22-1.69-2.54-1.13-4.38-3.13-5.51-6.01s-1.69-6.86-1.69-11.95.53-9.29,1.58-12.17c1.05-2.88,2.83-4.9,5.33-6.05s5.88-1.73,10.15-1.73c3.84,0,6.91.38,9.22,1.15,2.3.77,3.97,2.11,5,4.03,1.03,1.92,1.55,4.63,1.55,8.14,0,2.59-.52,4.64-1.55,6.16s-2.48,2.59-4.36,3.24c-1.87.65-4.08.97-6.62.97h-9.72c.1,1.97.4,3.54.9,4.72.5,1.18,1.44,2.02,2.81,2.52,1.37.5,3.35.76,5.94.76h11.3v6.26c-1.87.38-3.92.76-6.16,1.12-2.23.36-4.88.54-7.96.54ZM146.48,45.68h8.78c1.44,0,2.5-.29,3.17-.86.67-.58,1.01-1.61,1.01-3.1,0-1.39-.22-2.51-.65-3.35-.43-.84-1.11-1.44-2.02-1.8-.91-.36-2.14-.54-3.67-.54-1.63,0-2.93.28-3.89.83-.96.55-1.66,1.52-2.09,2.92-.43,1.39-.65,3.36-.65,5.9Z",
    fill: "currentcolor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M197.89,67.57l-26.93-38.66h10.73l27,38.66h-10.8ZM170.96,67.57l14.9-22.68,3.89,10.01-7.99,12.67h-10.8ZM193.71,51.73l-4.54-8.93,8.71-13.9h10.8l-14.98,22.82Z",
    fill: "currentcolor"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M213.87,67.57V14.29h22.54c3.6,0,6.6.64,9,1.91,2.4,1.27,4.31,3.1,5.72,5.47,1.42,2.38,2.41,5.2,2.99,8.46.58,3.26.86,6.86.86,10.8,0,6-.68,10.97-2.05,14.9s-3.42,6.88-6.16,8.82c-2.74,1.94-6.19,2.92-10.37,2.92h-22.54ZM224.52,57.99h10.8c2.21,0,3.96-.63,5.26-1.91,1.3-1.27,2.24-3.18,2.84-5.72.6-2.54.9-5.69.9-9.43,0-3.46-.19-6.3-.58-8.53-.38-2.23-.95-3.97-1.69-5.22-.75-1.25-1.68-2.11-2.81-2.59-1.13-.48-2.44-.72-3.92-.72h-10.8v34.13Z",
    fill: "currentcolor"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M269.81,68c-2.93,0-5.3-.86-7.13-2.59-1.83-1.73-2.74-4.13-2.74-7.2v-3.46c0-2.93,1.03-5.34,3.1-7.24,2.06-1.9,5.28-2.84,9.65-2.84h9.86v-2.66c0-1.2-.22-2.2-.65-2.99s-1.24-1.37-2.41-1.73c-1.18-.36-2.96-.54-5.36-.54h-11.59v-6.19c1.87-.58,4.04-1.08,6.52-1.51,2.47-.43,5.46-.65,8.96-.65,3.21,0,5.96.38,8.24,1.15,2.28.77,4.01,2.09,5.18,3.96,1.18,1.87,1.76,4.46,1.76,7.78v26.28h-8.42l-1.73-4.1c-.34.38-.91.82-1.73,1.3-.82.48-1.81.97-2.99,1.48-1.18.5-2.5.92-3.96,1.26-1.46.33-2.99.5-4.57.5ZM275.21,60.58c.48,0,1.02-.06,1.62-.18.6-.12,1.22-.26,1.87-.43.65-.17,1.25-.33,1.8-.5.55-.17,1.01-.32,1.37-.47.36-.14.59-.24.68-.29v-9l-6.48.43c-1.87.14-3.25.62-4.14,1.44-.89.82-1.33,1.92-1.33,3.31v1.58c0,.96.2,1.75.61,2.38.41.62.96,1.07,1.66,1.33.7.26,1.48.4,2.34.4Z",
    fill: "currentcolor"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M315.89,67.57c-2.98,0-5.39-.43-7.24-1.3-1.85-.86-3.18-2.3-4-4.32-.82-2.02-1.18-4.73-1.08-8.14l.36-16.34h-6.05v-6.84l6.41-1.73,1.44-10.8h8.42v10.8h9.07v8.57h-9.07v16.27c0,1.06.1,1.92.29,2.59.19.67.47,1.21.83,1.62.36.41.78.71,1.26.9.48.19.96.31,1.44.36l4.9.43v7.92h-6.98Z",
    fill: "currentcolor"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M345.48,67.93c-4.27,0-7.68-.56-10.22-1.69-2.54-1.13-4.38-3.13-5.51-6.01-1.13-2.88-1.69-6.86-1.69-11.95s.53-9.29,1.58-12.17c1.06-2.88,2.83-4.9,5.33-6.05,2.5-1.15,5.88-1.73,10.15-1.73,3.84,0,6.91.38,9.22,1.15,2.3.77,3.97,2.11,5,4.03,1.03,1.92,1.55,4.63,1.55,8.14,0,2.59-.52,4.64-1.55,6.16-1.03,1.51-2.48,2.59-4.36,3.24-1.87.65-4.08.97-6.62.97h-9.72c.1,1.97.4,3.54.9,4.72.5,1.18,1.44,2.02,2.81,2.52s3.35.76,5.94.76h11.3v6.26c-1.87.38-3.92.76-6.16,1.12-2.23.36-4.88.54-7.96.54ZM338.5,45.68h8.78c1.44,0,2.5-.29,3.17-.86.67-.58,1.01-1.61,1.01-3.1,0-1.39-.22-2.51-.65-3.35-.43-.84-1.1-1.44-2.02-1.8-.91-.36-2.14-.54-3.67-.54-1.63,0-2.93.28-3.89.83-.96.55-1.66,1.52-2.09,2.92-.43,1.39-.65,3.36-.65,5.9Z",
    fill: "currentcolor"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "8 57.94 18.93 64.25 54.02 64.25 64.95 57.94 64.95 56.25 8 56.25 8 57.94",
    fill: "currentcolor"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 45.29,
    width: 8,
    height: 10.96,
    fill: "currentcolor"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 45.29,
    width: 8,
    height: 10.96,
    fill: "currentcolor"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M36.48,74.38l-17.55-10.13H2.93l31.55,18.21c.62.36,1.31.54,2,.54s1.38-.18,2-.54l31.55-18.21h-16l-17.55,10.13Z",
    fill: "currentcolor"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 26.75,
    width: 8,
    height: 10.54,
    fill: "currentcolor"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 64.95,
    y: 26.75,
    width: 8,
    height: 10.54,
    fill: "currentcolor"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M36.48,8.62l17.55,10.13h16L38.48.54c-1.24-.71-2.76-.71-4,0L2.93,18.75h16l17.55-10.13Z",
    fill: "currentcolor"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "64.95 25.06 54.02 18.75 18.93 18.75 8 25.06 8 26.75 64.95 26.75 64.95 25.06",
    fill: "currentcolor"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 37.29,
    width: 56.95,
    height: 8,
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.b34613e1e1ee801fee7e71e8f92319ce.svg";
export { ForwardRef as ReactComponent };